export const deepObjectUpdater = (
  defaultEntry: object,
  patch: object
): object => {
  return Object.keys(patch).reduce(
    (updatedEntry, key) => {
      const value = patch[key];

      if (value === null) {
        updatedEntry[key] = null;
      } else if (Array.isArray(value)) {
        updatedEntry[key] = value;
      } else if (value && typeof value === "object" && !Array.isArray(value)) {
        updatedEntry[key] = deepObjectUpdater(updatedEntry[key] || {}, value);
      } else {
        updatedEntry[key] = value;
      }

      return updatedEntry;
    },
    { ...defaultEntry }
  );
};
